import { COMPANY } from "@/lib/api";
import { Award, Target, Heart } from "lucide-react";

export default function About() {
  return (
    <div className="bg-[#0a0a0b] text-white pt-32">
      {/* Hero */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20" data-testid="about-hero">
        <p className="label-overline">About Us · Launching Soon</p>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-5 tracking-tight max-w-4xl leading-[1.05]">
          Crafting <span className="italic text-[#c5a059]">premium</span> neighbourhoods <br className="hidden md:block" />
          in the heart of Madhya Pradesh.
        </h1>
        <p className="text-[#cfcfd2] text-lg mt-8 max-w-2xl leading-relaxed">
          {COMPANY} is a newly-founded plotted-community developer preparing to launch its inaugural
          layout at Shujalpur — a return to thoughtfully planned, transparent real estate
          for families across Madhya Pradesh.
        </p>
      </section>

      <div className="hairline max-w-7xl mx-auto" />

      {/* Story */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img
            src="https://images.unsplash.com/photo-1764222233275-87dc016c11dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            alt="Aerial view of layout"
            className="rounded-xl border border-[#2a2a2d] w-full h-full object-cover"
          />
        </div>
        <div className="lg:col-span-7 lg:pt-4">
          <p className="label-overline">Our Story</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 tracking-tight">A new venture, a generational promise.</h2>
          <p className="text-[#cfcfd2] mt-6 leading-relaxed">
            {COMPANY} is a newly-founded real estate development house, born out of a simple
            conviction — that plotted living in tier-2 and tier-3 India deserves the same
            craftsmanship, transparency, and aesthetic care reserved for the metros.
          </p>
          <p className="text-[#8f8f94] mt-4 leading-relaxed">
            We are preparing to launch our inaugural project at Shujalpur: a master-planned
            layout where every road, park, and plot has been imagined from scratch. Bookings will
            open at launch — for now, you are welcome to register for launch updates.
          </p>
        </div>
      </section>

      {/* Pillars */}
      <section className="bg-[#08080a] border-y border-[#1f1f22] py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <p className="label-overline">Pillars</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 tracking-tight">The values we build on.</h2>
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {[
              { icon: Target, t: "Vision", d: "Develop sustainable plotted layouts that respect local heritage while introducing modern infrastructure." },
              { icon: Heart, t: "Mission", d: "Make premium, transparent real estate ownership accessible to families across Madhya Pradesh." },
              { icon: Award, t: "Promise", d: "Clear titles, on-time delivery, and after-sale support that lasts well beyond registration." },
            ].map(({ icon: Icon, t, d }) => (
              <div key={t} className="card-hover bg-[#0f0f11] border border-[#2a2a2d] rounded-xl p-8">
                <Icon size={28} strokeWidth={1.4} className="text-[#c5a059]" />
                <h3 className="font-serif text-2xl mt-5">{t}</h3>
                <p className="text-[#8f8f94] text-sm mt-3 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership note */}
      <section className="max-w-4xl mx-auto px-6 lg:px-12 py-24 text-center">
        <p className="label-overline">A Note From Leadership</p>
        <p className="font-serif text-3xl md:text-4xl italic text-[#cfcfd2] mt-6 leading-relaxed">
          "Land is more than property — it is the silent foundation of every family's story.
          We treat it with the patience and craftsmanship it deserves."
        </p>
        <p className="text-sm text-[#8f8f94] tracking-[0.2em] uppercase mt-8">— The Aryavarta Team</p>
      </section>
    </div>
  );
}
